/**
 * server configuration
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {isAbsoluteUrl} from "./utils";


export const REST_SERVER_BASE_URL = getServerURL(window.location.host);

export const REST_CALL_LOGIN = {method: 'POST', path: '/login'};
export const REST_CALL_LOAD_CONFIGURATION = {method: 'GET', path: '/config'};
export const REST_CALL_VERIFY = {method: 'POST', path: '/verify'};

export const REST_CALL_SAVE_OBJECT = {method: 'PUT', path: '/object'};
export const REST_CALL_LOAD_OBJECT = {method: 'GET', path: '/object/<id>'};
export const REST_CALL_LOAD_ALL_TAGS = {method: 'GET', path: '/alltags'};
export const REST_CALL_DELETE_OBJECT = {method: 'PUT', path: '/recycle/object/<id>'};
export const REST_CALL_UNDELETE_OBJECT = {method: 'GET', path: '/recycle/object/<id>'};
export const REST_CALL_GET_OBJECT_HISTORY = {method: 'GET', path: '/history/object/<id>'};
export const REST_CALL_GET_USER_HISTORY = {method: 'GET', path: '/history/user/<id>/<index>/<count>'};
export const REST_CALL_GET_GLOBAL_HISTORY = {method: 'GET', path: '/history/global/<index>/<count>'};

export const REST_CALL_LIST_TYPES = {method: 'GET', path: '/typelist'};
export const REST_CALL_OBJECT_LIST = {method: 'POST', path: '/objectlist'};
export const REST_CALL_OBJECT_QUERY = {method: 'POST', path: '/objectquery'};
export const REST_CALL_FILTER_GROUPS = {method: 'GET', path: '/filtergroups/<id>'};

export const REST_CALL_UPLOAD_MEDIA_FILE = {method: 'POST', path: '/upload/media'};

export const REST_CALL_EXPORT_DATABASE = {method: 'GET', path: '/admin/dump/objects?history=<history>&passwords=<passwords>'};
export const REST_CALL_EXPORT_UPLOADS = {method: 'GET', path: '/admin/dump/uploads'};
export const REST_CALL_EXPORT_USERCONTENT = {method: 'GET', path: '/admin/dump/usercontent'};
export const REST_CALL_IMPORT_DATABASE = {method: 'POST', path: '/admin/dump/objects'};
export const REST_CALL_IMPORT_UPLOADS = {method: 'POST', path: '/admin/dump/uploads'};
export const REST_CALL_IMPORT_USERCONTENT = {method: 'POST', path: '/admin/dump/usercontent'};
export const REST_CALL_SYNC_DATABASE = {method: 'GET', path: '/admin/sync/objects'};
export const REST_CALL_SYNC_UPLOADS = {method: 'GET', path: '/admin/sync/uploads'};
export const REST_CALL_UPDATE_SERVER_LOG = {method: 'GET', path: '/logging/get/<maxbytes>'};
export const REST_CALL_UPDATE_SERVER_CONNECTIONS = {method: 'GET', path: '/state/connections'}
export const REST_CALL_UPDATE_SERVER_STORYLINES = {method: 'GET', path: '/state/storylines'}
export const REST_CALL_UPDATE_SERVER_SENSOR_STATE = {method: 'GET', path: '/state/sensors'}
export const REST_CALL_UPDATE_SERVER_STORY_STATE = {method: 'GET', path: '/state/stories'}
export const REST_CALL_CANCEL_STORYLINE = {method: 'DELETE', path: '/storyline/<id>'}
export const REST_CALL_UPDATE_SERVER_PROPERTY_GLOBALS = {method: 'GET', path: '/state/property/globals'}
export const REST_CALL_UPDATE_SERVER_PROPERTY_LIST = {method: 'GET', path: '/state/property/list'}
export const REST_CALL_UPDATE_SERVER_PROPERTY_VALUES = {method: 'GET', path: '/state/property/values/<id>'}
export const REST_CALL_DELETE_SERVER_PROPERTY_VALUE = {method: 'DELETE', path: '/state/property/values/<id>/<individual>'}

export const REST_CALL_GET_ABOUT_INFO = {method: 'GET', path: '/info/about'}

export const REST_CALL_REFRESH_BOX = {method: 'GET', path: '/box/<cbox>/refresh'};
export const REST_CALL_ANSWER_INTERACTION = {method: 'POST', path: '/interaction/<scene_id>/<index>/<answer>?boxname=<cbox>'};
export const REST_CALL_MENU_ACTION = {method: 'POST', path: '/menuaction/<menu_id>/<index>?boxname=<cbox>'};

export const REST_CALL_SHORTCUT_ACTION = {method: 'POST', path: '/shortcutaction/<cbox_name>/<index>'};

export const REST_CALL_GET_NEXT_SEQUENCE_VALUE = {method: 'GET', path: '/sequence/<id>/next'};

export const DEMO_MODE = window.location.host.endsWith(":4020");


export function patchServerUrl(url) {
    if (!REST_SERVER_BASE_URL) return url;
    if (!url) return url;
    if (isAbsoluteUrl(url)) return url;
    else if (url.startsWith("/")) return REST_SERVER_BASE_URL + url;
    else return REST_SERVER_BASE_URL + "/" + url;
}

/**
 * get server URL either for development or for production (depending on host port)
 * @author Jens Gruschel
*/
function getServerURL(host) {
    const DEV_NODE_SERVER_PORT = ":3000";
    const DEV_FLASK_SERVER_PORT = ":4000";
    if (host.endsWith(DEV_NODE_SERVER_PORT)) {
        // use Flask server port 4000 if Node server port 3000 is used (for development)
        return 'http://' + host.slice(0, -DEV_NODE_SERVER_PORT.length) + DEV_FLASK_SERVER_PORT;
    }
    else {
        // otherwise use no special server, but just the one used for this application (for production)
        return '';
    }
}


